module.exports = __webpack_public_path__ + "img/img-4.4f5b486c.png";